import { defineMessages } from 'react-intl';

import type { FullHeadMPRErrorCode } from './types';

export const fullHeadMprErrorMessages = defineMessages<FullHeadMPRErrorCode>({
  'data-stream': {
    id: 'global.defaultError',
    defaultMessage:
      'Something went wrong. Try again later or contact our support team.',
  },
  'missing-volume': {
    id: 'fullHeadMpr.noVolume',
    defaultMessage: 'DCCT volume is not available for this report.',
  },
  'start-viewer': {
    id: 'fullHeadMpr.error',
    defaultMessage: 'Full-head viewer failed to start.',
  },
});
